import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(props) {
    return /*#__PURE__*/ _jsx(Svg, _object_spread_props(_object_spread({
        viewBox: "0 0 26 26"
    }, props), {
        children: /*#__PURE__*/ _jsx("g", {
            id: "页面-1",
            stroke: "none",
            strokeWidth: "1",
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ _jsx("g", {
                id: "iPhone-SE",
                transform: "translate(-702.000000, -214.000000)",
                fill: "#C3C9D0",
                fillRule: "nonzero",
                children: /*#__PURE__*/ _jsxs("g", {
                    id: "H5_icon_x",
                    transform: "translate(702.000000, 214.000000)",
                    children: [
                        /*#__PURE__*/ _jsx("path", {
                            d: "M23.5774278,25.9179386 C22.9357415,25.919934 22.3217934,25.6572843 21.8811399,25.1922479 L0.726284214,4.10543336 C-0.242094738,3.14002074 -0.242094738,1.61091082 0.726284214,0.726489194 C1.69791276,-0.242163065 3.22847144,-0.242163065 4.11886014,0.726489194 L25.2737158,21.7323128 C26.2420947,22.6977254 26.2420947,24.2268353 25.2737158,25.1144966 C24.8528923,25.6161378 24.2333356,25.9095849 23.5774278,25.9179386 L23.5774278,25.9179386 Z",
                            id: "路径"
                        }),
                        /*#__PURE__*/ _jsx("path", {
                            d: "M2.4294267,26.000815 C1.78684109,26.0019075 1.1723002,25.7384997 0.73102843,25.2728152 C-0.243676143,24.3043462 -0.243676143,22.7703954 0.73102843,21.8831738 L21.8681002,0.726351726 C22.8395449,-0.242117242 24.3782089,-0.242117242 25.2714165,0.726351726 C26.2428612,1.69807059 26.2428612,3.22877154 25.2714165,4.11924301 L4.13108485,25.2760651 C3.68847362,25.7413757 3.07265526,26.0036493 2.4294267,26.000815 L2.4294267,26.000815 Z",
                            id: "路径"
                        })
                    ]
                })
            })
        })
    }));
};
export default Icon;
